import * as types from '../actions/types';
import Cookies from 'js-cookie';

const initialState = {
  isFirstLogin: Cookies.get('is_first_login') === 'true',
};

export default function firstLoginReducer(state = initialState, action = undefined) {
  switch (action.type) {
    case types.SET_FIRST_LOGIN:
      return { ...state, isFirstLogin: true };
    case types.CLEAR_FIRST_LOGIN:
      return { ...state, isFirstLogin: false };
    default:
      return state;
  }
}
